import UserNoWallet from './UserNoWallet';
import Avatar from '../../avatar/Avatar';
import UserWalletMobileCard from './UserWalletMobileCard';
import useGetUserTier from '../../../services/user/queries/useGetUserTier';
import LoadingSpinner from '../../../components/LoadingSpinner/LoadingSpinner';
import TierAvatarProgress from '../../avatar/TierAvatarProgress';
import { useSelector } from 'react-redux';
import { ReducerState } from '@/services/common/lib/reducerState';

const UserProfileMobile = () => {
  // TODO remove and use address from privy
  const address = true;
  const user = useSelector((state: ReducerState) => state.auth);

  const { isLoading, isSuccess, data } = useGetUserTier({
    userId: user.id || '',
  });

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!user || !user.id || !isSuccess || !data) {
    return null;
  }

  const userTier = data.data;

  return (
    <div className="h-[68px] w-full rounded-[20px] bg-ph-violet-dark">
      <div className="flex h-full w-full items-center justify-center rounded-[20px] bg-phenom-border-glow-small p-[1px]">
        <div className="flex h-full w-full items-center justify-center gap-4 rounded-[20px] bg-ph-violet-dark p-3">
          {!address ? (
            <>
              <TierAvatarProgress
                className="h-[52px] w-[52px]"
                small
                progressPercentage={userTier.tierProgressPercentage}
              >
                <Avatar className="!h-14 !w-14" userId={user.id} />
              </TierAvatarProgress>

              <div className="flex items-center gap-1">
                <h2 className="text-base font-semibold text-ph-gray-white">{user.alias}</h2>
              </div>
              <UserNoWallet />
            </>
          ) : (
            <UserWalletMobileCard />
          )}
        </div>
      </div>
    </div>
  );
};

export default UserProfileMobile;
